import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  inject,
  input,
  OnInit,
  signal,
  TemplateRef,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import { SvgComponent } from 'icon';
import { randomString } from 'utils';
import { TooltipService } from '../tooltip.service';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'tooltip',
  templateUrl: './tooltip.component.html',
  styleUrls: ['./tooltip.component.scss'],
  encapsulation: ViewEncapsulation.None,
  imports: [SvgComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TooltipComponent implements OnInit {
  private tooltipService = inject(TooltipService);
  private el = inject(ElementRef);
  @ViewChild('tooltipContent') public tooltipContent: TemplateRef<HTMLElement>;
  public icon = input('tooltip');
  public iconClass = input('md:mr-1 normal');
  public name = input<string>();
  public iconClasses = signal<string>(null);
  public id = randomString(5);
  public timer: NodeJS.Timeout;

  public ngOnInit() {
    this.iconClasses.set(this.iconClass());
    this.tooltipService.onUpdates.subscribe(event => {
      if (event && event.id === this.id) {
        this.iconClasses.set(this.iconClass() + ' active');
      } else {
        this.iconClasses.set(this.iconClass());
      }
    });
  }

  public mouseover() {
    this.show(this.id);
  }

  public mouseout() {
    this.hide();
  }

  public touchstart(event: TouchEvent) {
    event.preventDefault();
    event.stopPropagation();
    this.show(this.id);
  }

  private show(id: string) {
    this.tooltipService.show(this.tooltipContent, this.el, id);

    if (this.name()) {
      clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        this.tooltipService.setUserReadTooltip(this.name());
      }, 2000);
    }
  }

  private hide() {
    this.tooltipService.hide();
    clearTimeout(this.timer);
  }
}
